module.exports = __webpack_public_path__ + "static/img/2-3.af909d6a.jpg";